import ResponseStatus from '../constants/ResponseStatus';
import { fetchRecentActivityData } from '../veevaIdApi';
import { showErrorNotificationFromResponse } from './errorUtils';

/**
 * @typedef RecentActivityDetail
 * @property {string} sourceIp
 * @property {Date | null} loginDate
 * @property {string} loginFormatted
 */

/**
 * @typedef RecentActivity
 * @property {number} vuid
 * @property {string} status
 * @property {Date | null} lastLogin
 * @property {string} lastLoginFormatted
 * @property {string} country
 * @property {string} userAgent
 * @property {string} platform
 * @property {number} loginCount
 * @property {RecentActivityDetail[]} recentActivityDetailList
 */

/**
 * Fetches recent activity data and transforms date strings into Date objects on success.
 * @returns {Promise<RecentActivity[]>} A promise that resolves to an array of recent activity objects, or an empty array on failure.
 */
const getRecentActivityData = async () => {
    const response = await fetchRecentActivityData();
    if (response.responseStatus !== ResponseStatus.SUCCESS) {
        showErrorNotificationFromResponse(response);
        return [];
    }
    const recentActivitiesWithFormattedLastLogin = response.data.map((activity) => ({
        ...activity,
        lastLogin: activity.lastLogin && new Date(activity.lastLogin),
        recentActivityDetailList: activity.recentActivityDetailList.map((detail) => ({
            ...detail,
            loginDate: detail.loginDate && new Date(detail.loginDate),
        })),
    }));

    return recentActivitiesWithFormattedLastLogin;
};

export default getRecentActivityData;
